// extracted by mini-css-extract-plugin
export default {"btn-view-icon":"ViewInfoButton_btn-view-icon__iNvt7","btn-view-icon-icon":"ViewInfoButton_btn-view-icon-icon__HzhFM"};